import 'angularjs-geolocation';

export default 'geolocation';
